module.exports = {
	title: 'غاتسبي',
	legalName: 'إسماعيل غلو',
	description: 'بداية غاتسبي مع ترجمة والكثير من الميزات الرائعة الأخرى',
	address: {
		city: 'الرشيدية',
		region: 'درعة تافيلالت',
		country: 'المغرب'
	}
}
